export { default as ListView } from 'providers/components/ProvidersListView';
export { default as FormView } from 'providers/components/ProviderFormView';



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/components/index.js